import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Reverie',
    description:
        'Imagined Light, a generative series of dream portraits: a thousand sunrises that never rose.',
    url: getOrigin()
}

export const navLinks = [
    { href: '/', label: 'Gallery' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]
